<div class="grid grid-nogutter mb-3">
  <div class="col-12 md:col-6 sm:col-12 sm:mb-2">
    <h6 class="m-0">{{ title }}</h6>
  </div>
</div>
<div class="projects-data">
  <div class="grid grid-nogutter">
    <div class="col-12 p-0">
      <p-table
        styleClass="p-datatable-sm p-datatable-sm--normal"
        [value]="dynamicCredential"
        [paginator]="true"
        [rows]="10"
        [tableStyle]="{ 'min-width': '50rem' }"
        [showCurrentPageReport]="true"
        currentPageReportTemplate="Showing {first} - {last} of {totalRecords}"
        autoLayout="true"
        [scrollable]="true"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width:10%">S.No</th>
            <th style="width:15%">
              Name
            </th>
            <th style="width: 25%">
              Description
            </th>
            <th style="width:15%; text-align: center;">
              {{'Documentation Required' | sentenceCase}}
            </th>
            @if(sessionUser.firm.expiredCredentialApproval){
            <th style="width:15%; text-align: center;">
              {{'Yearly Renewal' | sentenceCase}}
            </th>
            }
            <th style="width:30%; text-align: center;" >
              Status
            </th>
            @if(isEditingEnabled){
              @if (helperService.checkResponsive()) {
                <th alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
                } @else {
                <th style="width: auto">
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
              }
              <ng-template #frozenHeader>
              Actions
              </ng-template>
            }
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-credential let-rowIndex="rowIndex">
          <tr>
            <td>{{ rowIndex + 1 }}</td>
            <td>{{ credential.name }}</td>
            <td>{{ credential.description }}</td>
            @if(credential.isDocumentationRequired){
             <td style="padding-left: 1rem; text-align: center;">
                <span class="{{helperService.getEnvironmentName()}}-icon icon-check-outlined freshgreen"></span>
            </td> 
            }
            @else {
              <td style="padding-left: 1rem; text-align: center;" >
                 <span class="{{helperService.getEnvironmentName()}}-icon icon-close-outlined red"></span>
             </td> 
            }
            @if(sessionUser.firm.expiredCredentialApproval){
              @if(credential.isYearlyRenewal){
                <td style="padding-left: 1rem; text-align: center;">
                  <span class="{{helperService.getEnvironmentName()}}-icon icon-check-outlined freshgreen"></span>
              </td> 
              }
              @else {
                <td style="padding-left: 1rem; text-align: center;" >
                    <span class="{{helperService.getEnvironmentName()}}-icon icon-close-outlined red"></span>
                </td> 
              }
            }

            <td style="text-align: center;">
              @if(!credential.isArchived){
                <p-tag value="Active" [rounded]="true" class="pillActive" />
              }
              @else {
                <p-tag value="Inactive" [rounded]="true" class="pillInactive"  />
              }
            </td>
            @if(isEditingEnabled){
              @if (helperService.checkResponsive()) {
                <td alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } @else {
                <td class="pl-0">
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } 
               <ng-template #frozenData>
                 <div class="wrap-actions flex align-items-center gap-2">
                   <p-button
                     pTooltip="Edit" 
                     tooltipPosition="top"
                     [rounded]="true"
                     [text]="true"
                     icon="true"
                     (click)="goToEdit(credential)"
                   >
                     <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                   </p-button>
                   @if(credential?.firm) {
                     <p-button
                       [pTooltip]="credential.isArchived? 'Activate': 'Deactivate'"
                       tooltipPosition="top"  
                       (click)="onArchive($event, credential)"
                       [rounded]="true"
                       [text]="true"
                       icon="true"
                     >
                       <span class="{{helperService.getEnvironmentName()}}-icon icon-archive-outlined"></span>
                       
                     </p-button>
                     <p-button
                       pTooltip="Delete" 
                       tooltipPosition="top"
                       [rounded]="true"
                       [text]="true"
                       icon="true"
                       (click)="onDelete($event, credential)"
                     >
                       <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                     </p-button>
                   }
                 </div>
               </ng-template>
            }
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
